import { render } from "./PaginationControl.vue?vue&type=template&id=3ea47e00&scoped=true"
import script from "./PaginationControl.vue?vue&type=script&lang=js"
export * from "./PaginationControl.vue?vue&type=script&lang=js"

import "./PaginationControl.vue?vue&type=style&index=0&id=3ea47e00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea47e00"]])

export default __exports__